<template>
  <v-dialog v-model="modal" width="700">
    <v-card>
      <v-toolbar color="primary" flat dark>
        <v-toolbar-title>Simpan {{ isPengumuman ? 'Pengumuman' : 'Kuesioner' }}</v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="modal = false"><v-icon color="white">mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text class="black--text pa-5">
        <div class="subtitle-1 font-weight-medium">Simpan sebagai draft atau simpan dan tayangkan ?</div>
        <span>Pilih metode penyimpanan di bawah ini</span>
        <v-row class="mt-5">
          <v-col cols="12" md="6" sm="12">
            <v-card>
              <v-toolbar flat>
                <v-toolbar-title>Draft</v-toolbar-title>
                <v-spacer />
                <v-chip small outlined color="grey">Draft</v-chip>
              </v-toolbar>
              <v-card-text>
                <div class="mb-5">
                  {{ isPengumuman ? 'Pengumuman' : 'Kuisioner' }} yang disimpan berstatus draft tidak akan muncul di publik serta dapat diubah kembali
                </div>
                <br />
                <v-btn block outlined rounded color="primary" @click="$emit('save', 1)">
                  <span class="text-capitalize">Simpan sebagai draft</span>
                </v-btn>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="6" sm="12">
            <v-card>
              <v-toolbar flat>
                <v-toolbar-title>Tayang</v-toolbar-title>
                <v-spacer />
                <v-chip small outlined color="success">Tayang</v-chip>
              </v-toolbar>
              <v-card-text>
                <div class="mb-5">
                  {{ isPengumuman ? 'Pengumuman' : 'Kuisioner' }} yang disimpan dengan status tayang akan dapat diakses oleh publik sesuai waktu yang telah
                  diatur pada informasi umum
                </div>
                <v-btn block rounded color="primary" @click="$emit('save', 2)">
                  <span class="text-capitalize">Simpan dan tayangkan</span>
                </v-btn>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    isPengumuman: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      modal: false,
    }
  },
  methods: {
    open() {
      this.modal = true
    },
  },
}
</script>
